<div class="modal fade" id="{{modalId}}" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-xl">
		<div class="modal-content">
			<div *ngIf="pageLoading1" class="loader text-center">
				<img src="../../assets/img/loading.gif" />
				<p style="color: black;font-weight: bolder;">Loading...</p>
			</div>
			<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
				<div class="modal-header text-center row g-1">
					<h4 class="modal-title mb-0 col-3 text-start">
						<strong>
							{{uId ? details?.unique_id : "Create Task"}}
						</strong>
					</h4>
					<div class="col-2">
						<div class="ng-select-material">
							<ng-select [items]="statusList" bindValue="id" bindLabel="name" [clearable]="false"
								placeholder="Status*" formControlName="status_id" id="status_id" appearance="outline"
								[ngClass]="{'is-invalid':showError('status_id')}">
							</ng-select>
						</div>
						<p *ngIf="showError('status_id')" class="text-danger">
							<span *ngIf="f.status_id.errors?.required">
								Required
							</span>
							<span *ngIf="f.status_id.errors?.incorrect">
								{{customError.status_id}}
							</span>
						</p>
					</div>
					<div class="col-3">
						<div class="input-group">
							<div class="form-floating">
								<input class="form-control" [ngClass]="{'is-invalid':showError('fin_date')}"
									placeholder="" formControlName="fin_date" ngbDatepicker id="fin_date"
									#fin_date="ngbDatepicker" [minDate]="minDate" [container]="'body'" />
								<label for="fin_date">Finished Date</label>
							</div>
							<button class="btn btn-outline-secondary" (click)="fin_date.toggle()" type="button">
								<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
							</button>
						</div>
						<p *ngIf="showError('fin_date')" class="text-danger">
							<span *ngIf="f.fin_date.errors?.required">
								Required
							</span>
							<span *ngIf="f.fin_date.errors?.ngbDate">
								Invalid
							</span>
							<span *ngIf="f.fin_date.errors?.incorrect">
								{{customError.fin_date}}
							</span>
						</p>
					</div>
					<div class="col-3 text-start">
						@if(navbar.user?.tms_access?.finish_task){
						<mat-checkbox [color]="'primary'" formControlName="is_finished" id="is_finished">
							Finished
						</mat-checkbox>
						<p class="text-primary ps-4">
							<span *ngIf="f.is_finished.value">
								The task will not be visible
							</span>
						</p>
						}
					</div>
					<div class="col-1 text-end">
						<button type="button" class="btn-close" (click)="clearForm();"></button>
					</div>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-12">
							<div class="row mb-3">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<div class="form-floating">
										<input class="form-control" [ngClass]="{'is-invalid':showError('sub_task')}"
											id="sub_task" formControlName="sub_task" placeholder="">
										<label for="sub_task">Task*</label>
									</div>
									<p *ngIf="showError('sub_task')" class="text-danger">
										<span *ngIf="f.sub_task.errors?.required">
											Required
										</span>
										<span *ngIf="f.sub_task.errors?.incorrect">
											{{customError.sub_task}}
										</span>
									</p>
								</div>
							</div>
							<div class="row mb-3">
								<div class="col">
									<div class="ng-select-material">
										<ng-select [items]="navbar.departmentList" bindValue="id" bindLabel="name"
											[clearable]="true" placeholder="Department*" formControlName="department_id"
											id="department_id" appearance="outline"
											[ngClass]="{'is-invalid':showError('department_id')}">
										</ng-select>
									</div>
									<p *ngIf="showError('department_id')" class="text-danger">
										<span *ngIf="f.department_id.errors?.required">
											Required
										</span>
										<span *ngIf="f.department_id.errors?.incorrect">
											{{customError.department_id}}
										</span>
									</p>
								</div>
								<div class="col">
									<div class="ng-select-material">
										<ng-select [items]="userList" bindValue="id" bindLabel="full_name"
											[clearable]="true" placeholder="Lead*" formControlName="lead_id"
											id="lead_id" appearance="outline"
											[ngClass]="{'is-invalid':showError('lead_id')}">
										</ng-select>
									</div>
									<p *ngIf="showError('lead_id')" class="text-danger">
										<span *ngIf="f.lead_id.errors?.required">
											Required
										</span>
										<span *ngIf="f.lead_id.errors?.incorrect">
											{{customError.lead_id}}
										</span>
									</p>
								</div>
								<div class="col">
									<div class="ng-select-material">
										<ng-select [items]="userList" bindValue="id" bindLabel="full_name"
											[clearable]="true" placeholder="Assigned To*" formControlName="assigned_id"
											id="assigned_id" appearance="outline"
											[ngClass]="{'is-invalid':showError('assigned_id')}">
										</ng-select>
									</div>
									<p *ngIf="showError('assigned_id')" class="text-danger">
										<span *ngIf="f.assigned_id.errors?.required">
											Required
										</span>
										<span *ngIf="f.assigned_id.errors?.incorrect">
											{{customError.assigned_id}}
										</span>
									</p>
								</div>
								<div class="col">
									<div class="input-group">
										<div class="form-floating">
											<input class="form-control"
												[ngClass]="{'is-invalid':showError('start_date')}" placeholder=""
												formControlName="start_date" ngbDatepicker id="start_date"
												#start_date="ngbDatepicker" [minDate]="minDate" [container]="'body'" />
											<label for="start_date">Start Date</label>
										</div>
										<button class="btn btn-outline-secondary" (click)="start_date.toggle()"
											type="button">
											<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
										</button>
									</div>
									<p *ngIf="showError('start_date')" class="text-danger">
										<span *ngIf="f.start_date.errors?.required">
											Required
										</span>
										<span *ngIf="f.start_date.errors?.ngbDate">
											Invalid
										</span>
										<span *ngIf="f.start_date.errors?.incorrect">
											{{customError.start_date}}
										</span>
									</p>
								</div>
								<div class="col">
									<div class="input-group">
										<div class="form-floating">
											<input class="form-control" [ngClass]="{'is-invalid':showError('due_date')}"
												placeholder="" formControlName="due_date" ngbDatepicker id="due_date"
												#due_date="ngbDatepicker" [minDate]="minDate" [container]="'body'" />
											<label for="due_date">Due Date*</label>
										</div>
										<button class="btn btn-outline-secondary" (click)="due_date.toggle()"
											type="button">
											<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
										</button>
									</div>
									<p *ngIf="showError('due_date')" class="text-danger">
										<span *ngIf="f.due_date.errors?.required">
											Required
										</span>
										<span *ngIf="f.due_date.errors?.ngbDate">
											Invalid
										</span>
										<span *ngIf="f.due_date.errors?.incorrect">
											{{customError.due_date}}
										</span>
									</p>
								</div>
							</div>
							<div class="row mb-3">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<div class="form-floating">
										<textarea class="form-control" rows="3"
											[ngClass]="{'is-invalid':showError('notes')}" id="notes"
											formControlName="notes" placeholder=""></textarea>
										<label for="notes">Notes</label>
									</div>
									<p *ngIf="showError('notes')" class="text-danger">
										<span *ngIf="f.notes.errors?.required">
											Required
										</span>
										<span *ngIf="f.notes.errors?.incorrect">
											{{customError.notes}}
										</span>
									</p>
								</div>
							</div>
							<div class="row mb-3">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<button type="submit" class="btn btn-sm btn-primary me-1" *ngIf="showSubmitBtn">
										<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
										<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
										Submit
									</button>
									<button type="button" class="btn btn-sm btn-secondary"
										(click)="clearForm();">Cancel</button>
								</div>
							</div>

						</div>
					</div>
				</div>
			</form>
			<div class="modal-body" *ngIf="uId">
				<form [formGroup]="commentForm" (ngSubmit)="saveComment()" #modform="ngForm" class="comment-form">
					<div class="row">
						<div class="col-9">
							<div class="d-flex mb-2">
								<div
									class="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-3 comment-avatar fw-bold">
									{{getLoggedInUserInitials()}}
								</div>
								<div class="flex-grow-1">
									<textarea class="form-control" rows="3" placeholder="Write a comment..."
										formControlName="comment" id="comment"
										[ngClass]="{'is-invalid':showErrorComment('comment')}"></textarea>
									<p *ngIf="showErrorComment('comment')" class="text-danger">
										<span *ngIf="fc.comment.errors?.required">
											Required
										</span>
									</p>
									<div class="mt-2 text-end">
										<label class="float-start">
											{{getFileName(fc.attachment.value)}}
										</label>
										<button class="btn btn-sm btn-primary" type="submit">
											<fa-icon *ngIf="!showCommentLoader" [icon]="['fas', 'save']"></fa-icon>
											<fa-icon *ngIf="showCommentLoader" [icon]="['fas', 'spinner']"
												animation="spin"></fa-icon>
											{{fc.id.value?'Edit Comment':'Add Comment'}}
										</button>
									</div>
								</div>
							</div>
						</div>
						<div class="col-3">
							<div class="flex-grow-1">
								<ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="fileUpload($event)"
									[multiple]="false">
									<ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
										<div style="text-align: center;">
											<label>Drop file here</label><br>
											<label>OR</label><br>
											<button type="button" class="btn btn-primary btn-sm"
												(click)="openFileSelector()">
												@if(fileUploaderLoader){
												<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
												}
												Browse
											</button>
										</div>
									</ng-template>
								</ngx-file-drop>
							</div>
						</div>
					</div>
				</form>
				<div class="row">
					<div class="col-12">
						<!-- <h4>Comments</h4> -->
						<div class="comment-scroll">
							@for (commentObj of comments; track commentObj.id) {
							<div class="comment-box">
								<div class="d-flex mb-2">
									<div
										class="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-3 comment-avatar fw-bold">
										{{getInitials(commentObj.updated_by_name)}}
									</div>
									<div>
										<h6 class="mb-0">
											{{commentObj.updated_by_name}}
										</h6>
										<small class="text-muted">
											{{commentObj.created_at_updated}}
										</small>
									</div>
								</div>
								<div *ngIf="!commentObj.isEdit">
									<div class="icon-container" *ngIf="commentObj.attachment">
										<file-icon [file]="commentObj.attachment"></file-icon>
										@if (navbar.user.id == commentObj.updated_by){
										<fa-icon [icon]="['fas', 'times-circle']" class="delete-icon text-danger"
											matTooltip="Delete" (click)="deleteCommentFile(commentObj);"></fa-icon>
										}
									</div>
									<p class="mb-0">{{commentObj.comment}}</p>
								</div>
								<div *ngIf="commentObj.isEdit">
									<textarea class="form-control" rows="3" placeholder="Write a comment..."
										[(ngModel)]="commentObj.comment" id="comment{{commentObj.id}}"></textarea>
									<div class="mt-2 text-end">
										<button class="btn btn-sm btn-primary" type="button"
											(click)="updateComment(commentObj)" matTooltip="Update">
											<fa-icon *ngIf="!commentObj.showCommentLoader"
												[icon]="['fas', 'check']"></fa-icon>
											<fa-icon *ngIf="commentObj.showCommentLoader" [icon]="['fas', 'spinner']"
												animation="spin"></fa-icon>
										</button>
										<button class="btn btn-sm btn-secondary ms-1" type="button"
											(click)="bindEdit(commentObj,false)" matTooltip="Cancel">
											<fa-icon [icon]="['fas', 'times']"></fa-icon>
										</button>
									</div>
								</div>
								<div class="comment-actions">
									@if (navbar.user.dec_id == commentObj.updated_by) {
									<a (click)="bindEdit(commentObj,true)">
										<fa-icon [icon]="['fas','edit']"></fa-icon>
										Edit
									</a>
									<a (click)="deleteComment(commentObj)">
										<fa-icon [icon]="['fas','trash-alt']"></fa-icon>
										Delete
									</a>
									}
								</div>
							</div>
							}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>